import { render } from "./IpBlocked.vue?vue&type=template&id=61e03cde&scoped=true"
import script from "./IpBlocked.vue?vue&type=script&lang=js"
export * from "./IpBlocked.vue?vue&type=script&lang=js"

import "./IpBlocked.vue?vue&type=style&index=0&id=61e03cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e03cde"]])

export default __exports__